const defaultCustomClass = {
  popup: 'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
  htmlContainer: 'text-black-paint text-white'
}

export async function showConfirmation (options = {}) {
  const result = await globalThis.Swal.fire({
    animation: false,
    heightAuto: false,
    icon: 'warning',
    showCancelButton: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
    ...options,
    customClass: {
      ...defaultCustomClass,
      ...options.customClass
    }
  })

  return result.isConfirmed
}
